"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _Tab = _interopRequireDefault(require("./Tab"));
var _TabNav = _interopRequireDefault(require("./TabNav"));
var _TabContent = _interopRequireDefault(require("./TabContent"));
const Tabs = _ref => {
  let {
    id,
    className,
    children,
    selected,
    onChange
  } = _ref;
  const [selectedTabKey, setSelectedTabKey] = (0, _arkReact.useInternalValue)(selected, '');
  const tabs = _react.default.useMemo(() => {
    const result = [];
    _react.default.Children.forEach(children, child => {
      if (! /*#__PURE__*/_react.default.isValidElement(child)) {
        return;
      }
      result.push(child);
    });
    return result;
  }, [children]);
  const activeTab = _react.default.useMemo(() => {
    if (!Array.isArray(tabs) || tabs.length === 0) return null;
    const activeTab = tabs.find(tabItem => tabItem.props.tabKey === selectedTabKey && tabItem.props.disable !== true);
    return activeTab !== undefined ? activeTab : tabs[0];
  }, [selectedTabKey, tabs]);
  const onTabSelected = tabKey => {
    if (selected == null) {
      setSelectedTabKey(tabKey);
    }
    if ((0, _ark.isFunction)(onChange)) onChange(tabKey);
  };
  const renderNav = () => tabs.map((tabItem, idx) => {
    const {
      tabKey,
      title,
      disable
    } = tabItem.props;
    const isActive = selectedTabKey === tabKey;
    return /*#__PURE__*/_react.default.createElement(_TabNav.default, {
      key: idx,
      active: isActive,
      disable: disable,
      onClick: () => onTabSelected(tabKey)
    }, title);
  });
  const renderCurrentTabContent = () => {
    if (activeTab === null) return null;
    return activeTab.props.children;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: (0, _arkReact.concatClassName)('tabs', className)
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: "tabNavs"
  }, renderNav()), /*#__PURE__*/_react.default.createElement(_TabContent.default, null, renderCurrentTabContent()));
};
process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  selected: _propTypes.default.string,
  onChange: _propTypes.default.func
} : void 0;
Tabs.defaultProps = {
  id: undefined,
  className: undefined,
  children: undefined,
  selected: undefined,
  onChange: undefined
};
var _default = exports.default = Object.assign(Tabs, {
  Tab: _Tab.default
});